// Textile Maison services
import { Sofa, Bed, Armchair } from "lucide-react";

const IMG = {
  chaise: "https://images.unsplash.com/photo-1503602642458-232111445657?w=600&q=80&auto=format&fit=crop",
  fauteuil: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&q=80&auto=format&fit=crop",
  canape2: "https://images.unsplash.com/photo-1555041469-a586c61ea9bc?w=600&q=80&auto=format&fit=crop",
  canape3: "https://images.unsplash.com/photo-1493663284031-b7e3aefcae8e?w=600&q=80&auto=format&fit=crop",
  canapeL: "https://images.unsplash.com/photo-1567016432779-094069958ea5?w=600&q=80&auto=format&fit=crop",
  canapeXL: "https://images.unsplash.com/photo-1540574163026-643ea20ade25?w=600&q=80&auto=format&fit=crop",
  matelasBebe: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=600&q=80&auto=format&fit=crop",
  matelas1: "https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?w=600&q=80&auto=format&fit=crop",
  matelas2: "https://images.unsplash.com/photo-1631049307264-da0ec9d70304?w=600&q=80&auto=format&fit=crop",
};

export const TEXTILE_SERVICES = [
  { id: "chaise_unite", name: "Chaise à l'unité", desc: "Chaise simple (assise tissu)", price: 10, icon: Armchair, image: IMG.chaise },
  { id: "chaises_4", name: "Lot de 4 chaises", desc: "Chaises simples (assises tissu)", price: 30, icon: Armchair, image: IMG.chaise },
  { id: "fauteuil", name: "Fauteuil", desc: "1 place individuelle", price: 30, icon: Armchair, image: IMG.fauteuil },
  { id: "canape_2p", name: "Canapé 2 places", desc: "Banquette ou canapé droit", price: 40, icon: Sofa, image: IMG.canape2 },
  { id: "canape_3p", name: "Canapé 3 places", desc: "Canapé droit standard", price: 50, icon: Sofa, image: IMG.canape3 },
  { id: "canape_45p", name: "Canapé 4-5 places", desc: "Grand canapé / d'angle compact", price: 70, icon: Sofa, image: IMG.canapeL },
  { id: "canape_6p", name: "Canapé 6+ places", desc: "Canapé d'angle XL / modulable", price: 100, icon: Sofa, image: IMG.canapeXL },
  { id: "matelas_bebe", name: "Matelas bébé", desc: "Matelas berceau / lit junior", price: 20, icon: Bed, image: IMG.matelasBebe },
  { id: "matelas_1p", name: "Matelas 1 place", desc: "90×190 ou 120×190", price: 40, icon: Bed, image: IMG.matelas1 },
  { id: "matelas_2p", name: "Matelas 2 places", desc: "140×190 ou plus", price: 50, icon: Bed, image: IMG.matelas2 },
];

export const getTextileService = (id) => TEXTILE_SERVICES.find((s) => s.id === id);

// Options supplémentaires nettoyage auto
export const AUTO_SUPPLEMENTS = [
  { id: "shampooing_5_sieges", label: "Shampooing des 5 sièges", desc: "Shampouinage complet des sièges", price: 20 },
  { id: "shampooing_siege", label: "Shampooing siège (à l'unité)", desc: "Par siège individuel", price: 5 },
  { id: "shampooing_sols", label: "Shampooing des sols", desc: "Moquettes et tapis de sol", price: 20 },
  { id: "poils", label: "Poils d'animaux", desc: "Selon l'état — de 5 à 10€", price: 5 },
  { id: "tres_sale", label: "Véhicule très sale", desc: "Encrassement important — de 5 à 20€", price: 5 },
];
